var exports = {
  "kL": "xa15a2ab7--9d26d7--container",
  "DD": "xa15a2ab7--9d26d7--title",
  "Qq": "xa15a2ab7--9d26d7--text",
};

module.exports = exports;
